<p-confirmDialog key="addvisitor" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Information-->
<div>
	<div class="InfoDiv">
		<label style="color: Red">* Required Field</label>
		<label style="color: Orange">* Optional but Recommended</label>
	</div>

	<!--Top Section-->
	<div class="TopGrid3Col">
		<!--Left Col-->
		<div class="Grid2Col">
			<label>First Name:</label>
			<input
				[disabled]="IsLoading() == true"
				type="text"
				class="form-control"
				[(ngModel)]="FirstName"
				placeholder="First Name"
				[style.border]="NoValue(FirstName) == true ? '2px solid red' : '1px solid #e5e6e7'"
			/>

			<label>Date of Birth:</label>
			<p-calendar [disabled]="IsLoading() == true" showIcon="true" showButtonBar="true" [(ngModel)]="DOB" name="DOB"></p-calendar>

			<label>Gender:</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="Gender" maxlength="1" placeholder="1 Character ex. M or F" />
		</div>

		<!--Middle Col-->
		<div class="Grid2Col">
			<label>Middle Name:</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="MiddleName" placeholder="Middle Name" />

			<label>Visitor Type:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="SelectedRace" [(ngModel)]="SelectedVisitorType">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstVisitorType" [ngValue]="o">
					{{ o.VisitorTypeDesc }}
				</option>
			</select>

			<label>Visitor Status:</label>
			<select
				[disabled]="IsLoading() == true"
				class="form-control"
				name="SelectedVisitorStatus"
				[(ngModel)]="SelectedVisitorStatus"
				[style.color]="SelectedVisitorStatus?.AllowAdmittance == 1 ? 'Black' : 'Red'"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstVisitorStatus" [ngValue]="o" [style.color]="o.AllowAdmittance == 1 ? 'Black' : 'Red'">
					{{ o.VisitorStatusDesc }}
				</option>
			</select>

			<label style="grid-column: 1/3; text-align: center">Photo:</label>
			<div class="PhotoMenuOuterDiv">
				<div class="PhotoDiv" [style.Background]="PhotoB64 == undefined || PhotoB64 == '' ? 'lightgray' : 'white'">
					<label *ngIf="PhotoB64 == undefined || PhotoB64 == ''" class="NoImageText">No Image</label>
					<img *ngIf="PhotoB64 != undefined && PhotoB64 != ''" [src]="PhotoB64" class="VisitorPhoto" />
				</div>
				<div>
					<input
						id="SelectedImage"
						type="file"
						(change)="onSelectedImageChange($event)"
						onclick="event.target.value=''"
						style="visibility: hidden; position: absolute"
						accept="image/*"
					/>
					<button class="btn btn-primary" (click)="onSelectFile()">Select File</button>
				</div>
			</div>
		</div>

		<!--Right Col-->
		<div class="Grid2Col">
			<label>Last Name:</label>
			<input
				[disabled]="IsLoading() == true"
				type="text"
				class="form-control"
				[(ngModel)]="LastName"
				placeholder="Last Name"
				[style.border]="NoValue(LastName) == true ? '2px solid red' : '1px solid #e5e6e7'"
			/>

			<label>Race:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="SelectedRace" [(ngModel)]="SelectedRace">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstRace" [ngValue]="o">
					{{ o.RaceDesc }}
				</option>
			</select>

			<label>Ethnicity:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="SelectedRace" [(ngModel)]="SelectedEthnicity">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstEthnicity" [ngValue]="o">
					{{ o.EthnicityDesc }}
				</option>
			</select>
		</div>
	</div>

	<!--Address/License Data-->
	<div class="BottomGrid2Col">
		<div class="Grid2Col">
			<label>Address:</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="Address" placeholder="Address" />

			<label>City:</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="City" placeholder="City" />

			<label>State:</label>
			<input
				[disabled]="IsLoading() == true"
				type="text"
				class="form-control"
				[(ngModel)]="State"
				maxlength="2"
				placeholder="2 Characters ex. PA, MD"
				[style.border]="NoValue(State) == true ? '2px solid orange' : '1px solid #e5e6e7'"
			/>

			<label>Zip:</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="Zip" placeholder="Zip" />
		</div>

		<div class="Grid2Col">
			<label>License Number:</label>
			<input
				[disabled]="IsLoading() == true"
				type="text"
				class="form-control"
				[(ngModel)]="LicenseNbr"
				placeholder="License Number"
				[style.border]="NoValue(LicenseNbr) == true ? '2px solid orange' : '1px solid #e5e6e7'"
			/>

			<label>Phone Number:</label>
			<input
				[disabled]="IsLoading() == true"
				type="text"
				class="form-control"
				[(ngModel)]="PhoneNumber"
				placeholder="Phone Number"
				[style.border]="NoValue(PhoneNumber) == true ? '2px solid orange' : '1px solid #e5e6e7'"
			/>

			<label>Email:</label>
			<input
				[disabled]="IsLoading() == true"
				type="text"
				class="form-control"
				[(ngModel)]="Email"
				placeholder="Email"
				[style.border]="NoValue(Email) == true ? '2px solid orange' : '1px solid #e5e6e7'"
			/>
		</div>
	</div>

	<!--Notes at Bottom-->
	<div class="CenterText ExtraTopMargin">
		<label>Notes:</label>
	</div>
	<div style="padding: 0px 20px">
		<textarea
			[disabled]="IsLoading() == true"
			class="TextArea"
			[(ngModel)]="Notes"
			maxlength="500"
			placeholder="Notes about the visitor. This will help operators identify the blocked visitor"
		></textarea>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="IsLoading() == true" class="btn btn-warning SmallLeftMargin" (click)="onClose()">Cancel</button>
</div>

<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
